import { css } from 'aphrodite';
import * as React from 'react';
import { useContext } from 'react';
import { ViewportContext } from '../../../hooks/useViewport';
import { white } from '../../../styles/colors';
import { styleSheet } from './styles';

export interface ILeadViewTitleProps {
	color?: string;
	size?: 'regular' | 'small';
	title: string;
}

export const LeadViewTitle: React.FC<ILeadViewTitleProps> = ({ color, size, title }) => {
	const { isBelowSmall } = useContext(ViewportContext);
	const isSmall = size === 'small' ? styleSheet.titleSmall : null;
	const titleMobile = isBelowSmall ? styleSheet.titleMobile : null;
	return (
		<div className={`${css(styleSheet.container)} lead-view-title`}>
			<div className={css(styleSheet.header)}>
				<div style={{ color: color || white }} className={css(styleSheet.title, isSmall, titleMobile)}>
					{title}
				</div>
			</div>
		</div>
	);
};
